import { useState } from 'react';

const tagDetails = [
  {
    key: '판금가공 전문',
    icon: 'ri-scissors-cut-line',
    color: 'orange',
    title: '판금가공 전문',
    subtitle: 'Sheet Metal Processing Expert',
    desc: '14년 이상의 판금가공 전문 노하우를 바탕으로 레이저 절단, 절곡, 용접, 조립까지 정밀한 가공을 제공합니다.',
    points: [
      { icon: 'ri-scissors-cut-line', text: 'BYSTRONIC 파이버 레이저 절단 (최대 6kW)' },
      { icon: 'ri-tools-line', text: '정밀 CNC 절곡 가공 (최대 3,000mm)' },
      { icon: 'ri-fire-line', text: 'TIG · MIG · CO₂ 용접 전문' },
      { icon: 'ri-stack-line', text: '소량 1개부터 대량 5,000개 이상 생산까지 대응' },
      { icon: 'ri-test-tube-line', text: '시제품 및 샘플 제작 가능' },
      { icon: 'ri-trophy-line', text: '대량제작 다수 납품 실적 보유' },
    ],
  },
  {
    key: '올인원 생산',
    icon: 'ri-settings-3-line',
    color: 'orange',
    title: '올인원 생산',
    subtitle: 'All-in-One Production',
    desc: 'CAD 설계부터 레이저 가공, 절곡, 용접, 조립, 납품까지 전 공정을 한 곳에서 처리하는 원스톱 생산 시스템입니다.',
    points: [
      { icon: 'ri-pencil-ruler-2-line', text: '자체 CAD 설계 및 도면 제작' },
      { icon: 'ri-scissors-cut-line', text: '레이저 절단 → 절곡 → 용접 일괄 처리' },
      { icon: 'ri-settings-3-line', text: '완제품 조립 및 검수' },
      { icon: 'ri-truck-line', text: '납품까지 원스톱 진행' },
      { icon: 'ri-time-line', text: '빠른 납기 및 일정 관리' },
    ],
  },
  {
    key: '품질 보증',
    icon: 'ri-award-line',
    color: 'orange',
    title: '품질 보증',
    subtitle: 'Quality Assurance',
    desc: '체계적인 품질 관리 시스템과 인증을 통해 고객이 요구하는 정밀도와 신뢰성을 보장합니다.',
    points: [
      { icon: 'ri-government-line', text: '조달청 입찰 가능 제품 보유' },
      { icon: 'ri-file-list-3-line', text: '직접생산 증명서 보유' },
      { icon: 'ri-building-2-line', text: '대기업 협력사 공급망 참여' },
      { icon: 'ri-shield-check-line', text: '전수 검사 및 품질 기록 관리' },
      { icon: 'ri-customer-service-2-line', text: '납품 후 A/S 및 재가공 대응' },
    ],
  },
];

export default function AboutSection() {
  const [activeTag, setActiveTag] = useState<string | null>(null);

  const LOGO_URL = 'https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png';

  const LogoSlot = ({ index, factory }: { index: number; factory: 1 | 2 }) => (
    <div
      className="relative rounded-xl overflow-hidden border border-gray-100 bg-white flex items-center justify-center"
      style={{ aspectRatio: '4/3' }}
    >
      <img
        src={LOGO_URL}
        alt={`NS-TECH ${factory}공장`}
        className="w-3/4 h-3/4 object-contain p-3"
      />
      <span className="absolute bottom-2 left-0 right-0 text-center text-xs text-gray-400 font-medium">
        {factory}공장 · {index + 1}
      </span>
    </div>
  );

  const activeDetail = tagDetails.find(t => t.key === activeTag) || null;

  return (
    <section id="about" className="py-16 md:py-28 px-5 md:px-20 bg-gray-50">
      <div className="max-w-6xl mx-auto">

        {/* 태그 상세보기 모달 */}
        {activeDetail && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center px-4"
            style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
            onClick={() => setActiveTag(null)}
          >
            <div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
              onClick={e => e.stopPropagation()}
            >
              {/* 모달 헤더 */}
              <div className="bg-gray-900 px-6 py-5 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className={`${activeDetail.icon} text-white text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-white font-bold text-base">{activeDetail.title}</h3>
                    <p className="text-orange-400 text-xs mt-0.5">{activeDetail.subtitle}</p>
                  </div>
                </div>
                <button
                  onClick={() => setActiveTag(null)}
                  className="cursor-pointer w-8 h-8 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-colors"
                >
                  <i className="ri-close-line text-white text-base"></i>
                </button>
              </div>

              {/* 모달 본문 */}
              <div className="p-6">
                <p className="text-gray-600 text-sm leading-relaxed mb-5">{activeDetail.desc}</p>
                <div className="flex flex-col gap-2.5">
                  {activeDetail.points.map((pt, i) => (
                    <div key={i} className="flex items-center gap-3 bg-orange-50 border border-orange-100 rounded-xl px-4 py-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                        <i className={`${pt.icon} text-white text-sm`}></i>
                      </div>
                      <span className="text-sm text-gray-800 font-medium">{pt.text}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="px-6 pb-5">
                <button
                  onClick={() => setActiveTag(null)}
                  className="cursor-pointer w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-xl text-sm transition-colors whitespace-nowrap"
                >
                  닫기
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 회사 개요 */}
        <div className="mb-16 md:mb-24">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-orange-500 text-xs font-semibold uppercase tracking-widest">Company Overview</span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-2 mb-3">회사 개요</h2>
            <div className="w-10 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* 왼쪽: 회사 기본 정보 테이블 */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="bg-gray-900 px-6 py-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                  <i className="ri-building-4-line text-white text-sm"></i>
                </div>
                <h3 className="text-white font-bold text-sm md:text-base">기업 기본 정보</h3>
              </div>
              <div className="divide-y divide-gray-50">
                {[
                  { label: '회사명', value: '(주)엔에스테크', icon: 'ri-building-2-line' },
                  { label: '대표자', value: '안영달', icon: 'ri-user-line' },
                  { label: '사업자번호', value: '231-81-06719', icon: 'ri-file-text-line' },
                  { label: '설립연도', value: '2012년', icon: 'ri-calendar-line' },
                  { label: '소재지', value: '경기도 포천시 소흘읍 소흘로 11', icon: 'ri-map-pin-line' },
                  { label: '전화', value: '031-541-1902', icon: 'ri-phone-line' },
                  { label: '팩스', value: '031-541-1903', icon: 'ri-printer-line' },
                  { label: '이메일', value: 'nstech01@naver.com', icon: 'ri-mail-line' },
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-3 px-5 py-3.5 hover:bg-orange-50/40 transition-colors">
                    <div className="w-7 h-7 flex items-center justify-center bg-orange-100 rounded-full flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-orange-500 text-xs`}></i>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-0.5 sm:gap-3 min-w-0">
                      <span className="text-xs text-gray-400 font-medium whitespace-nowrap w-20 flex-shrink-0">{item.label}</span>
                      <span className="text-sm text-gray-800 font-medium break-all">{item.value}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* 오른쪽: 주요 사업 + 인증/특징 */}
            <div className="flex flex-col gap-5">
              {/* 주요 사업 */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="bg-gray-900 px-6 py-4 flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className="ri-tools-line text-white text-sm"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm md:text-base">주요 사업</h3>
                </div>
                <div className="p-5 grid grid-cols-1 gap-2.5">
                  {[
                    { icon: 'ri-pencil-ruler-2-line', title: 'CAD 설계', desc: '자체 설계 및 도면 제작' },
                    { icon: 'ri-settings-3-line', title: '조립 및 납품', desc: '완제품 조립부터 납품까지' },
                    { icon: 'ri-fire-line', title: '용접 가공', desc: 'TIG·MIG·CO₂ 용접 전문' },
                    { icon: 'ri-tools-line', title: '절곡 가공', desc: '정밀 벤딩 및 성형 가공' },
                    { icon: 'ri-scissors-cut-line', title: '레이저 가공', desc: 'BYSTRONIC 파이버 레이저 절단' },
                  ].map((item, i) => (
                    <div key={i} className="flex items-center gap-3 bg-orange-50 border border-orange-100 rounded-xl px-4 py-3">
                      <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                        <i className={`${item.icon} text-white text-sm`}></i>
                      </div>
                      <div>
                        <p className="text-xs font-bold text-gray-800">{item.title}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* 주요 인증 및 특징 */}
              <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-5 flex flex-col gap-3 border border-gray-700">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className="ri-award-line text-white text-xs"></i>
                  </div>
                  <h3 className="text-white font-bold text-sm">주요 인증 및 특징</h3>
                </div>
                {[
                  { icon: 'ri-government-line', text: '조달청 입찰 가능 제품 보유' },
                  { icon: 'ri-file-list-3-line', text: '직접생산 증명서 보유' },
                  { icon: 'ri-building-2-line', text: '대기업 협력사 공급망 참여' },
                  { icon: 'ri-stack-line', text: '소량(1개) 제작 가능' },
                  { icon: 'ri-test-tube-line', text: '시제품 및 샘플 제작 가능' },
                  { icon: 'ri-trophy-line', text: '대량제작 다수 납품 실적 보유' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5">
                    <div className="w-6 h-6 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-white text-xs`}></i>
                    </div>
                    <span className="text-gray-200 text-xs font-medium">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 대표 인사말 */}
        <div className="mb-16 md:mb-24">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-orange-500 text-xs font-semibold uppercase tracking-widest">CEO Message</span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-2 mb-3">대표 인사말</h2>
            <div className="w-10 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 items-start">
            <div className="flex flex-col items-center gap-4">
              <div className="relative w-full max-w-xs mx-auto">
                <img
                  src="https://static.readdy.ai/image/7455c6c7e49181bdad2ed4b44e4d279c/b09fe7069d8db297eae61b8e105adfe6.png"
                  alt="NS-TECH 대표"
                  className="w-full h-56 md:h-80 object-contain object-center rounded-2xl shadow-lg bg-white p-5"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900/80 to-transparent rounded-b-2xl px-5 py-4">
                  <p className="text-white font-bold text-sm md:text-base">NS-TECH 대표</p>
                  <p className="text-orange-300 text-xs mt-0.5">판금가공 전문 제조기업</p>
                </div>
              </div>
              <div className="w-full max-w-xs mx-auto bg-gray-900 rounded-xl px-5 py-4 flex items-start gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0 mt-0.5">
                  <i className="ri-lightbulb-line text-white text-sm"></i>
                </div>
                <div>
                  <p className="text-orange-400 text-xs font-semibold uppercase tracking-wider mb-1.5">회사 철학</p>
                  <p className="text-white text-sm leading-relaxed">
                    품질과 신뢰를 바탕으로<br />고객과 함께 성장하는<br />제조 파트너
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col justify-start">
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10">
                <p className="text-gray-700 text-sm md:text-[15px] leading-8 whitespace-pre-line">
{`안녕하십니까.
NS-TECH 홈페이지를 찾아주신 모든 분들께 감사드립니다.

저희 NS-TECH는 CAD 설계를 기반으로 레이저 가공, 절곡, 용접, 조립까지 이어지는 원스톱 판금 가공 솔루션을 제공하는 전문 제조 기업입니다.

고객 맞춤형 제작과 체계적인 품질 관리를 통해 정확하고 안정적인 가공 품질을 실현하며, 대기업 협력사 공급망 참여 경험을 바탕으로 믿을 수 있는 제조 파트너로 자리매김하고 있습니다.

앞으로도 NS-TECH는 품질과 신뢰, 기술 혁신을 핵심 가치로 삼아 고객과 함께 성장하며, 최적의 솔루션을 제공하는 기업이 되도록 최선을 다하겠습니다.

감사합니다.`}
                </p>
                <div className="mt-6 pt-5 border-t border-gray-100 flex items-center justify-end gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full">
                    <i className="ri-double-quotes-r text-orange-500 text-sm"></i>
                  </div>
                  <p className="text-gray-900 font-bold text-sm">NS-TECH 대표</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 회사 소개 + 특징 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-14 mb-16 md:mb-24">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/8ab3982e1bf9b1aa5600461cdd8dc573.jpg"
              alt="BYSTRONIC 레이저 가공 장비"
              className="w-full h-56 md:h-full object-cover rounded-2xl"
            />
            <div className="absolute top-4 left-4 flex flex-col gap-2">
              {['14년 경험', '직접생산 증명서 보유', '대기업 협력사'].map((label, i) => (
                <span key={i} className="px-4 py-2 bg-orange-500 text-white rounded-full text-xs font-bold shadow-lg whitespace-nowrap flex items-center gap-1.5">
                  <i className={`${i === 0 ? 'ri-award-line' : i === 1 ? 'ri-file-text-line' : 'ri-building-2-line'}`}></i>
                  {label}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-between gap-5">
            <div>
              <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                NS-TECH는<br />신뢰할 수 있는<br />제조 파트너입니다
              </h2>
              <div className="flex flex-wrap gap-2 mb-6">
                {tagDetails.map((tag, i) => (
                  <button
                    key={i}
                    onClick={() => setActiveTag(tag.key)}
                    className={`cursor-pointer px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all flex items-center gap-1.5 ${
                      i === 0
                        ? 'border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white'
                        : 'text-gray-500 border border-gray-200 hover:border-orange-400 hover:text-orange-500'
                    }`}
                  >
                    {tag.key}
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </button>
                ))}
              </div>

              <div className="grid grid-cols-2 gap-2.5">
                {[
                  { icon: 'ri-government-line', title: '조달청 입찰 가능', sub: '제품 보유' },
                  { icon: 'ri-file-list-3-line', title: '조달청 입찰', sub: '가능 제품 등록' },
                  { icon: 'ri-stack-line', title: '소량 제작 가능', sub: '1개부터 주문 가능' },
                  { icon: 'ri-test-tube-line', title: '시제품 & 샘플', sub: '제작 가능' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-2.5 bg-orange-50 border border-orange-100 rounded-xl px-3 py-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-white text-sm`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-orange-600 font-semibold leading-tight">{item.title}</p>
                      <p className="text-xs text-orange-500 leading-tight mt-0.5">{item.sub}</p>
                    </div>
                  </div>
                ))}
                <div className="col-span-2 flex items-center gap-2.5 bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl px-3 py-3 shadow-sm">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                    <i className="ri-pencil-ruler-2-line text-white text-sm"></i>
                  </div>
                  <div>
                    <p className="text-xs text-white font-semibold leading-tight">자체 설계 가능</p>
                    <p className="text-xs text-white/85 leading-tight mt-0.5">CAD 설계부터 제작 납품까지 올인원</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-5 md:p-7 flex flex-col md:flex-row items-center gap-5">
              <div className="flex-1">
                <span className="text-orange-500 text-xs font-medium uppercase tracking-wider">핵심 역량</span>
                <h3 className="text-white text-lg md:text-xl font-bold mt-2 mb-2.5">
                  설계부터 조립까지<br />올인원 솔루션
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
                  CAD 설계를 기반으로 레이저 가공, 벤딩, 용접 및 조립까지 전 공정을 아우르는 올인원 생산 시스템을 통해 고객의 다양한 요구에 최적의 솔루션을 제공합니다.
                </p>
              </div>
              <div className="w-28 h-28 md:w-36 md:h-36 flex-shrink-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_ab59a7316a22b861f2ba784a38515fa3_185b8515.jpg"
                  alt="정밀 금속 부품"
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
            </div>
          </div>
        </div>

        {/* 공장 생산 현장 */}
        <div className="mb-4">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-orange-500 text-xs font-semibold uppercase tracking-widest">Factory</span>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mt-2 mb-3">생산 현장</h2>
            <div className="w-10 h-1 bg-orange-500 mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 gap-12 md:gap-16">
            {([1, 2] as const).map((factoryNum) => (
              <div key={factoryNum}>
                <div className="flex items-center gap-2.5 mb-5">
                  <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className={`${factoryNum === 1 ? 'ri-building-line' : 'ri-building-2-line'} text-white text-sm`}></i>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-gray-900">NS-TECH {factoryNum}공장 생산 현장</h3>
                </div>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-2.5 md:gap-4">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <LogoSlot key={idx} index={idx} factory={factoryNum} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
